/**
 * Calm Lumina — 香型多选筛选器
 *
 * 行为：
 * - 「全部」：清空选择，显示所有产品
 * - 香型按钮：多选 toggle；OR 逻辑（命中任一选中香型即显示）
 * - 通过 data-scents 读取产品 tag（空格分隔，如 "scent-檀香 scent-沉香"）
 * - 与 Dawn Section Rendering / facets 重绘兼容（事件委托 + section:load）
 */
(function () {
  'use strict';

  var HIDDEN_CLASS = 'scent-filter-item--hidden';
  var ACTIVE_CLASS = 'is-active';

  /**
   * 解析产品 data-scents 字符串为 tag 数组
   * @param {string} value
   * @returns {string[]}
   */
  function parseScents(value) {
    if (!value || typeof value !== 'string') return [];
    return value
      .trim()
      .split(/\s+/)
      .filter(function (tag) {
        return tag.indexOf('scent-') === 0;
      });
  }

  /**
   * 初始化单个筛选栏实例（与最近的 product-grid 联动）
   * @param {HTMLElement} root - [data-scent-filter]
   */
  function initFilter(root) {
    if (!root || root.dataset.scentFilterReady === 'true') return;
    root.dataset.scentFilterReady = 'true';

    var pills = root.querySelectorAll('[data-scent]');
    var countEl = root.querySelector('[data-scent-count]');
    var emptyEl = root.querySelector('[data-scent-empty]');
    var showCount = root.getAttribute('data-show-count') !== 'false';

    /** @type {Set<string>} 当前选中的香型 tag（不含 all） */
    var selected = new Set();

    /**
     * 查找同一 section 内的产品网格项
     * 优先：同一 ProductGridContainer；否则全局 #product-grid
     */
    function getItems() {
      var container =
        root.closest('#ProductGridContainer') ||
        root.closest('.product-grid-container') ||
        document.getElementById('ProductGridContainer');

      var scope = container || document;
      var items = scope.querySelectorAll('[data-scent-item]');
      if (items.length) return items;

      // 兜底：#product-grid 下的 .grid__item（若遗漏 data-scent-item）
      var grid = scope.querySelector('#product-grid') || document.getElementById('product-grid');
      if (!grid) return [];
      return grid.querySelectorAll('.grid__item');
    }

    function updatePillStates() {
      pills.forEach(function (btn) {
        var value = btn.getAttribute('data-scent');
        var isAll = value === 'all';
        var active = isAll ? selected.size === 0 : selected.has(value);
        btn.classList.toggle(ACTIVE_CLASS, active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function applyFilter() {
      var items = getItems();
      var visible = 0;

      items.forEach(function (item) {
        var productScents = parseScents(item.getAttribute('data-scents') || '');
        var match;

        if (selected.size === 0) {
          match = true;
        } else {
          // OR：任一选中香型命中
          match = false;
          selected.forEach(function (scent) {
            if (productScents.indexOf(scent) !== -1) match = true;
          });
        }

        item.classList.toggle(HIDDEN_CLASS, !match);
        if (match) visible += 1;
      });

      if (countEl && showCount) {
        if (selected.size === 0) {
          countEl.hidden = true;
          countEl.textContent = '';
        } else {
          countEl.hidden = false;
          countEl.textContent = '显示 ' + visible + ' 件';
        }
      }

      if (emptyEl) {
        var hasItems = items.length > 0;
        emptyEl.hidden = !(hasItems && visible === 0 && selected.size > 0);
      }
    }

    function onPillClick(event) {
      var btn = event.target.closest('[data-scent]');
      if (!btn || !root.contains(btn)) return;

      var value = btn.getAttribute('data-scent');
      if (!value) return;

      if (value === 'all') {
        selected.clear();
      } else if (selected.has(value)) {
        selected.delete(value);
      } else {
        selected.add(value);
      }

      updatePillStates();
      applyFilter();
    }

    root.addEventListener('click', onPillClick);

    // 对外：section 重绘后可调用（保留选择状态并重新应用）
    root._scentFilterApply = function () {
      updatePillStates();
      applyFilter();
    };

    updatePillStates();
    applyFilter();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-scent-filter]');
    roots.forEach(initFilter);

    // section 重绘后 data-scent-filter-ready 会随 DOM 重建消失，新节点需再 init
    // 若网格被替换但筛选栏仍在，重新 apply
    roots.forEach(function (root) {
      if (typeof root._scentFilterApply === 'function') {
        root._scentFilterApply();
      }
    });
  }

  function onReady() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  // Dawn facets / Section Rendering 后重新绑定
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  // 部分 Dawn 版本在 AJAX 过滤后派发自定义事件；保险再扫一次
  document.addEventListener('facet:update', function () {
    // 网格可能替换：清除 ready 标记逻辑由新 DOM 自然完成；对仍在的 filter 重新 apply
    setTimeout(function () {
      document.querySelectorAll('[data-scent-filter]').forEach(function (root) {
        // 新节点未 ready 则 init；旧节点 re-apply
        if (root.dataset.scentFilterReady === 'true' && root._scentFilterApply) {
          root._scentFilterApply();
        } else {
          root.dataset.scentFilterReady = '';
          initFilter(root);
        }
      });
    }, 0);
  });
})();
